/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Linear_Stall_To_DoubleInputs */

const en_us2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression adjusted after a stall`)
};

const pt_br2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressão ajustada depois de uma estagnação`)
};

const es_419_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresión ajustada tras un estancamiento`)
};

const pt_pt2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressão ajustada depois de uma estagnação`)
};

const fr_fr2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression ajustée après une stagnation`)
};

const de_de2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression nach Stillstand angepasst`)
};

const it_it2_progression_linear_stall_to_double = /** @type {(inputs: Progression_Linear_Stall_To_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressione adattata dopo uno stallo`)
};

/**
* | output |
* | --- |
* | "Progression adjusted after a stall" |
*
* @param {Progression_Linear_Stall_To_DoubleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_linear_stall_to_double = /** @type {((inputs?: Progression_Linear_Stall_To_DoubleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Linear_Stall_To_DoubleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_linear_stall_to_double(inputs)
	if (locale === "es-419") return es_419_progression_linear_stall_to_double(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_linear_stall_to_double(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_linear_stall_to_double(inputs)
	if (locale === "de-DE") return de_de2_progression_linear_stall_to_double(inputs)
	if (locale === "it-IT") return it_it2_progression_linear_stall_to_double(inputs)
	return en_us2_progression_linear_stall_to_double(inputs)
});
export { progression_linear_stall_to_double as "progression.linear_stall_to_double" }